var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"value":_vm.SnackBarComponent.SnackbarVmodel,"color":_vm.SnackBarComponent.SnackbarColor,"top":_vm.SnackBarComponent.Top,"timeout":_vm.SnackBarComponent.timeout}},[_c('div',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.SnackBarComponent.SnackbarText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }